import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IntellectualProperty: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M15.3333 27.3327V15.9993M27.3333 13.9993V8.66602C27.3333 6.45688 25.5425 4.66602 23.3333 4.66602H8C5.79087 4.66602 4 6.45688 4 8.66602V22.666C4 24.8752 5.79086 26.666 8 26.666H12.6667M19.3333 27.3327V23.3327M19.3333 23.3327V15.9993C19.3333 15.9993 21.4299 15.9696 23.3333 15.9993C25.7102 16.0365 27.3333 16.666 27.3333 19.3327C27.3333 21.9993 25.8252 23.3327 23.3333 23.3327C21.3333 23.3327 19.3333 23.3327 19.3333 23.3327Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M23.9974 10H18.6641" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 16H8" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 20H8" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" />
    <circle cx="10.6667" cy="10.6667" r="2.66667" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" />
  </SvgIcon>
);

export const IntellectualPropertyDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M15.3333 27.3327V15.9993M27.3333 13.9993V8.66602C27.3333 6.45688 25.5425 4.66602 23.3333 4.66602H8C5.79087 4.66602 4 6.45688 4 8.66602V22.666C4 24.8752 5.79086 26.666 8 26.666H12.6667M19.3333 27.3327V23.3327M19.3333 23.3327V15.9993C19.3333 15.9993 21.4299 15.9696 23.3333 15.9993C25.7102 16.0365 27.3333 16.666 27.3333 19.3327C27.3333 21.9993 25.8252 23.3327 23.3333 23.3327C21.3333 23.3327 19.3333 23.3327 19.3333 23.3327Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M23.9974 10H18.6641" stroke="#090C18" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 16H8" stroke="#090C18" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 20H8" stroke="#090C18" strokeWidth="2" strokeLinecap="round" />
    <circle cx="10.6667" cy="10.6667" r="2.66667" stroke="#090C18" strokeWidth="2" strokeLinecap="round" />
  </SvgIcon>
);
